import runes from "runes";


export const getSelectedText = () => {
    let selectedText = '';

    // window.getSelection
    if (window.getSelection) {
        selectedText = window.getSelection();
    }
    // document.getSelection
    else if (document.getSelection) {
        selectedText = document.getSelection();
    }
    // document.selection
    else if (document.selection) {
        selectedText = document.selection.createRange().text;
    }
    return selectedText?.toString?.();
}

export const getCaretPosition = (node) => {
    let range = window.getSelection().getRangeAt(0),
    preCaretRange = range.cloneRange(),
    caretPosition,
    tmp = document.createElement("div");
    preCaretRange.selectNodeContents(node);
    preCaretRange.setEnd(range.endContainer, range.endOffset);
    tmp.appendChild(preCaretRange.cloneContents());
    caretPosition = tmp.innerHTML.length;
    return caretPosition;
}

const createRange = (node, chars, range) => {
    if (!range) {
        range = document.createRange()
        range.selectNode(node);
        range.setStart(node, 0);
    }

    if (chars.count === 0) {
        range.setEnd(node, chars.count);
    } else if (node && chars.count > 0) {
        if (node.nodeType === Node.TEXT_NODE) {
            if (node.textContent.length < chars.count) {
                chars.count -= node.textContent.length;
            } else {
                range.setEnd(node, chars.count);
                chars.count = 0;
            }
        } else {
            for (let lp of node.childNodes) {
                range = createRange(lp, chars, range);
                if (chars.count === 0) {
                  break;
                }
            }              
        }
    }
    return range;
};

/**
 * @param  {string} str=""
 * remove 1024 char restrict
 * runes using emonji splice
 */
export const removeMoreNumberChar = (numCharRes = 0, str = "") => {
    try{
        return runes.substr(str, 0, numCharRes);
    } catch(e) {}
};

/**
 * Set cursor postion for content editable element
 * @param {*} element
 * @param {*} pos
 */
export const setCaretPosition = (element, pos) => {
    if (!element) return;
    if (pos >= 0) {
        const selection = window.getSelection();
        // Use the element itself as the root for range calculation so positions map to the editable content
        const range = createRange(element, { count: pos });
        if (range) {
            range.collapse(false);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
};

/**
 * Set cursor position for input(textbox) element
 * @param {*} element
 * @param {*} pos
 */
export const setInputCaretPosition = (element, pos) => {
    if (element.selectionStart) {
        element.focus();
        element.setSelectionRange(pos, pos);
    }
    else {
        element.focus();
    }
}

/**
 * Set cursor position immediately after a given DOM element
 * Useful for positioning cursor after inserted mention spans
 * @param {HTMLElement} element - The element to position cursor after
 */
export const setCaretAfterElement = (element) => {
    if (!element) return;
    
    const selection = window.getSelection();
    const range = document.createRange();
    
    // Position the range after the element
    range.setStartAfter(element);
    range.setEndAfter(element);
    range.collapse(true);
    
    selection.removeAllRanges();
    selection.addRange(range);
};

/**
 * Insert a space after a mention span and position cursor after it
 * This ensures consistent cursor positioning after mention insertion
 * @param {HTMLElement} messageContent - The contenteditable element containing mentions
 * @param {number} delay - Optional delay in milliseconds before positioning cursor (default: 0)
 * @param {HTMLElement} newMentionSpan - Optional specific mention span to position cursor after. If not provided, uses the last mention span.
 */
export const positionCursorAfterLastMention = (messageContent, delay = 0, newMentionSpan = null) => {
    if (!messageContent) return;
    
    setTimeout(() => {
        let targetMentionSpan = newMentionSpan;
        
        // If no specific mention span provided, find the last one
        if (!targetMentionSpan) {
            const allMentionSpans = messageContent.querySelectorAll('span[data-mentioned]');
            if (!allMentionSpans || allMentionSpans.length === 0) return;
            targetMentionSpan = allMentionSpans[allMentionSpans.length - 1];
        }
        
        // Verify the mention span exists and is within the messageContent
        if (!targetMentionSpan || !messageContent.contains(targetMentionSpan)) {
            return;
        }
        
        // Insert a space text node after the mention span if it doesn't exist
        let spaceTextNode = targetMentionSpan.nextSibling;
        
        // Check if there's already a text node with space immediately after
        if (!spaceTextNode || spaceTextNode.nodeType !== Node.TEXT_NODE || !spaceTextNode.textContent.startsWith(' ')) {
            // Create and insert a space text node
            spaceTextNode = document.createTextNode(' ');
            if (targetMentionSpan.parentNode) {
                const nextSibling = targetMentionSpan.nextSibling;
                targetMentionSpan.parentNode.insertBefore(spaceTextNode, nextSibling);
            }
        }
        
        // Position cursor after the space
        if (spaceTextNode && spaceTextNode.nodeType === Node.TEXT_NODE) {
            const selection = window.getSelection();
            const range = document.createRange();
            range.setStart(spaceTextNode, 1); // Position after the space character
            range.setEnd(spaceTextNode, 1);
            range.collapse(true);
            selection.removeAllRanges();
            selection.addRange(range);
        } else {
            // Fallback: position cursor after the mention span
            setCaretAfterElement(targetMentionSpan);
        }
        messageContent.focus();
    }, delay);
};
